import { render } from "./ScreenerCard.vue?vue&type=template&id=0ca90bd0&scoped=true&ts=true"
import script from "./ScreenerCard.vue?vue&type=script&lang=ts"
export * from "./ScreenerCard.vue?vue&type=script&lang=ts"

import "./ScreenerCard.vue?vue&type=style&index=0&id=0ca90bd0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca90bd0"]])

export default __exports__